import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ApiApprovalGroupRequest } from "../apiClient/models";
import { OrganizationsClient } from "../apiClient/services";
import { ApprovalGroupOverview } from "../domain/approval-group";

@Injectable({
  providedIn: "root",
})
export class ApprovalGroupService {
  constructor(private organizationsClient: OrganizationsClient) {}

  public createApprovalGroup$(
    orgId: number,
    approvalGroup: ApiApprovalGroupRequest,
  ): Observable<ApprovalGroupOverview> {
    return this.organizationsClient
      .createOrganizationApprovalGroup({
        orgId,
        body: approvalGroup,
      })
      .pipe(map((response) => ApprovalGroupOverview.from(response)));
  }

  public updateApprovalGroup$(
    orgId: number,
    approvalGroupId: number,
    approvalGroup: ApiApprovalGroupRequest,
  ): Observable<ApprovalGroupOverview> {
    return this.organizationsClient
      .updateOrganizationApprovalGroup({
        orgId,
        approvalGroupId,
        body: approvalGroup,
      })
      .pipe(map((response) => ApprovalGroupOverview.from(response)));
  }

  public deleteApprovalGroup$(orgId: number, approvalGroupId: number): Observable<void> {
    return this.organizationsClient.deleteOrganizationApprovalGroup({
      orgId,
      approvalGroupId,
    });
  }
}
